import { IComponentsProps } from '../home';

// eslint-disable-next-line no-shadow
export enum ActionTypes {
  loadHotSite = 'LOAD_HOTSITE',
  updateHotSite = 'UPDATE_HOTSITE',
}

export interface IHotSiteState {
  components: Array<IComponentsProps>;
}

export interface ILoadHotSiteResponse {
  id?: string;
  slug: string | string[];
}
